<template>
	<Layout>
		<h1 class="u-a11y-visually-hidden">
			{{ $I18n.trans('arena.login.login.title') }}
		</h1>
		<input
			v-if="$Helpers.isSmartTV()"
			type="hidden"
			name="trigger-qr-login-modal"
		>
		<input
			v-else
			type="hidden"
			name="trigger-login-modal"
		>
		<input
			v-if="redirectUrl"
			type="hidden"
			name="login-redirect-url"
			:value="redirectUrl"
		>
		<input
			v-if="email"
			type="hidden"
			name="login-email"
			:value="email"
		>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';

export default {
	name:       'ViewLogin',
	components: { Layout },
	props:      {
		redirectUrl: {
			type:    String,
			default: null,
		},
		email: {
			type:    String,
			default: null,
		},
	},
};
</script>

<style>

</style>
